import React, { useEffect, useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  tableCellClasses,
  TableBody,
  IconButton,
  Button,
  Autocomplete,
  Grid,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ToggleButton,
  ToggleButtonGroup,
  Snackbar,
  Alert,
  Typography,
  CircularProgress,
} from "@mui/material";
import { CgMenuGridO } from "react-icons/cg";
import { LuLayoutList } from "react-icons/lu";
import { styled } from "@mui/material/styles";
import { MdOutlineModeEdit } from "react-icons/md";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { IoCalendarOutline, IoFilter } from "react-icons/io5";
import { useTheme } from "../../../style/theme";
import { IoIosArrowBack, IoIosArrowForward, IoMdClose } from "react-icons/io";
import dayjs from "dayjs";
import Textarea from "../../DashComponents/TextArea";
import { X } from "lucide-react";
import axios from "axios";
import { format, startOfWeek, addDays, parse, isAfter, isBefore, addHours, differenceInMinutes, isWithinInterval ,isSameDay } from "date-fns";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";

const AssignShiftModal = ({ open, handleClose ,fetchEmployeeShifts}) => {
  const { mode: themeMode } = useTheme();
  const [shiftOptions, setshiftOptions] = useState([]);
  const currentOrg = JSON.parse(localStorage.getItem("org"));
  const currentEmp = JSON.parse(localStorage.getItem("emp"));
  const todayStr = new Date().toISOString().split("T")[0];
  const [loading, setLoading] = useState(false);
  const [emp, setemp] = useState();
  const [employLists, setEmployLists] = useState([]);
  const { handleSubmit, control, reset, formState: { errors } } = useForm();
  console.log(emp, 'employListsemployLists')

  const fetchShifts = async () => {
    try {
      const response = await axios.get(
        `/hr/adminShift?orgId=${currentOrg?._id}`
      );
      const shifts = response?.data?.data;

      const formatted = shifts?.map((emp) => ({
        value: emp?._id,
        label: `${emp?.shiftName} ${emp?.workedTime?.from} - ${emp?.workedTime?.to}`,
      }));

      setshiftOptions(formatted);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchEmplyoees = async (search = "") => {
    try {
      const response = await axios.get(
        `/hr/employee?searchBy=firstName&search=${search}&sortBy=order&status=&page=1`
      );

      setEmployLists(response?.data?.employees);
    } catch (error) {
      console.error("Failed to fetch employees:", error);
    }
  };

  useEffect(() => {
    fetchShifts();
    fetchEmplyoees()
  }, []);

  // Form submit
  const onSubmit = async (data) => {
    const payload = {
      userId: emp,
      adminId:currentOrg?._id,
      shiftName: data.shiftName?.value,
      fromDate: data.fromDate,
      toDate: data.toDate,
      reason: data.reason,
      status: "approved"
    };
    console.log(payload, 'payloadpayload')

    try {
      setLoading(true);
      await axios.post("/hr/employeeShift", payload);
      fetchEmployeeShifts();
      handleClose();
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 0,
          bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
        }}
      >
        <div className="p-4 flex justify-between items-center">
          <Typography variant="h6" fontWeight="bold">
            Assign Shift
          </Typography>
          <button
            className="p-1 rounded-md border-none outline-none"
            onClick={handleClose}
            type="button"
            style={{ backgroundColor: themeMode === "light" ? "#dcdcdc" : "" }}
          >
            <X size={20} />
          </button>
        </div>
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <DialogContent
          sx={{
            bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
          }}
        >
          <div clasName="p-4">
            <FormControl fullWidth sx={{ mt: 1 }}>
              <label className="text-[14px] mb-1 block">Employee Name</label>
              <ReactSelect
                name='empId'
                options={employLists.map((emp) => ({
                  value: emp._id,
                  label: `${emp.firstName} ${emp.lastName}`,
                }))}
                value={employLists
                  .map((emp) => ({
                    value: emp._id,
                    label: `${emp.firstName} ${emp.lastName}`,
                  }))
                  .find((option) => option.value === emp)}
                onChange={(selectedOption) => setemp(selectedOption?.value)}
                placeholder="Select Employee"
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: themeMode === "light" ? "#fff" : "#1e1e1e",
                    color: themeMode === "light" ? "#000" : "#fff",
                    borderColor: themeMode === "light" ? "#ccc" : "#555",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: themeMode === "light" ? "#000" : "#fff",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    backgroundColor: themeMode === "light" ? "#fff" : "#141414",
                    color: themeMode === "light" ? "#000" : "#fff",
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused
                      ? themeMode === "light"
                        ? "#f0f0f0"
                        : "#2a2a2a"
                      : "transparent",
                    color: themeMode === "light" ? "#000" : "#fff",
                  }),
                }}
              />
            </FormControl>

            {/* Shift Name */}
            <FormControl fullWidth sx={{ mt: 1 }}>
              <label className="text-[14px]">Shift Name</label>
              <Controller
                name="shiftName"
                control={control}
                rules={{ required: "Shift is required" }}
                render={({ field }) => (
                  <>
                    <ReactSelect
                      {...field}
                      options={shiftOptions}
                      placeholder="Select shift"
                      isClearable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor:
                            themeMode === "light" ? "#fff" : "#141414",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          backgroundColor:
                            themeMode === "light" ? "#fff" : "#141414",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused
                            ? "#e0e0e0"
                            : "#f0f0f0",
                          color: "#000",
                        }),
                      }}
                    />
                    {errors?.shiftName && (
                      <span className="text-red-500 text-xs mt-1">
                        {errors.shiftName.message}
                      </span>
                    )}
                  </>
                )}
              />
            </FormControl>

            {/* From Date */}
            <Box className="mt-2">
              <label className="text-[14px] mt-2">From</label>

              <Controller
                name="fromDate"
                control={control}
                rules={{ required: true }}
                defaultValue={todayStr}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: todayStr }}
                  />
                )}
              />
            </Box>

            {/* To Date */}
            <label className="text-[14px] mt-2">To</label>
            <Controller
              name="toDate"
              control={control}
              rules={{ required: "To date is required" }}
              defaultValue={todayStr}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: todayStr }}
                  error={!!errors.toDate}
                  helperText={errors.toDate?.message}
                />
              )}
            />


            {/* Reason */}
            <label className="text-[14px] mt-2">Reason</label>
            <Controller
              name="reason"
              control={control}
              rules={{ required: "Reason is required" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  error={!!errors.reason}
                  helperText={errors.reason?.message}
                />
              )}
            />
          </div>
        </DialogContent>

        <div
          className={`p-4 flex justify-between items-center ${themeMode === "dark" ? "bg-[#141414]" : "bg-[#fff]"
            }`}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{ backgroundColor: "#0080FF", minWidth: 130 }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : (
              "Assign Shift"
            )}
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

export default function EmployeeShiftMapping() {
  const [activeTab, setActiveTab] = useState("list");
  const [selectedValue, setSelectedValue] = useState("today");

    
const DailyBasedEmployeeShiftMappingTableView = ({ employeeShifts, formattedDate }) => {
  const selectedDay = parse(formattedDate, "dd/MM/yyyy", new Date());

  
  const DEFAULT_SHIFT = {
    shiftName: {
      shiftName: "General Shift",
      workedTime: {
        from: "09:00 AM",
        to: "06:00 PM"
      }
    }
  };
  function formatTo12Hour(hour, minute) {
  // Handle undefined/null values
  if (hour === undefined || minute === undefined) return "12:00 AM";

  // Ensure integers
  hour = parseInt(hour);
  minute = parseInt(minute);

  // Determine AM or PM
  const ampm = hour >= 12 ? "PM" : "AM";

  // Convert 24-hour to 12-hour
  let formattedHour = hour % 12;
  formattedHour = formattedHour === 0 ? 12 : formattedHour;

  // Pad minutes with leading 0
  const formattedMinute = minute.toString().padStart(2, "0");

  return `${formattedHour}:${formattedMinute} ${ampm}`;
}


  // Map + inject default if no shift matches selected day
  const filteredEmployees = employeeShifts.map((emp) => {
    const dayShifts = emp.shifts.filter(shift =>
      isSameDay(new Date(shift.fromDate), selectedDay)
    );

      const DEFAULT_SHIFTS = {
       shiftName: {
        shiftName: "General Shift",
        workedTime: {
           from: formatTo12Hour(emp?.shiftStart?.hour, emp?.shiftStart?.minute),
      to: formatTo12Hour(emp?.shiftEnd?.hour, emp?.shiftEnd?.minute),
 }
      }
    };
console.log(DEFAULT_SHIFTS,"DEFAULT_SHIFTSDEFAULT_SHIFTS")
    return {
      ...emp,
      shifts: dayShifts.length ? dayShifts : [DEFAULT_SHIFT],
      isDefault: dayShifts.length === 0
    };
  });

  const getDynamicTimeColumns = (shifts) => {
    let minHour = 24;
    let maxHour = 0;

    shifts.forEach(emp => {
      emp.shifts.forEach(shift => {
        const from = parse(shift.shiftName.workedTime.from, "hh:mm a", new Date());
        const to = parse(shift.shiftName.workedTime.to, "hh:mm a", new Date());

        minHour = Math.min(minHour, from.getHours());
        maxHour = Math.max(maxHour, to.getHours());
      });
    });

    const hours = [];
    let current = new Date();
    current.setHours(minHour, 0, 0, 0);

    while (current.getHours() <= maxHour) {
      hours.push(format(current, "hh a"));
      current = addHours(current, 1);
    }

    return hours;
  };

  const TIME_COLUMNS = getDynamicTimeColumns(filteredEmployees);
  const parseTime = (str) => parse(str, "hh:mm a", new Date());
  const parseColumnTime = (col) => parse(col, "hh a", new Date());

  return (
    <TableContainer sx={{ overflowX: "auto", marginTop: "20px" }}>
      <Table>
        <TableHead>
          <TableRow sx={{ border: '1px solid #ccc' }}>
            <TableCell sx={{ border: '1px solid #ccc' }}>Employee</TableCell>
            {TIME_COLUMNS.map((col) => (
              <TableCell key={col} sx={{ border: '1px solid #ccc' }}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredEmployees.map((employee, empIdx) => {
            const rowCells = [];
            let timeIdx = 0;

            while (timeIdx < TIME_COLUMNS.length) {
              const currentTime = parseColumnTime(TIME_COLUMNS[timeIdx]);
              let shiftRendered = false;

              for (const shift of employee.shifts) {
                const from = parseTime(shift.shiftName.workedTime.from);
                const to = parseTime(shift.shiftName.workedTime.to);

                if (from.getHours() === currentTime.getHours()) {
                  const duration = differenceInMinutes(to, from);
                  const colSpan = Math.min(Math.ceil(duration / 60), TIME_COLUMNS.length - timeIdx);

                  rowCells.push(
                    <TableCell key={`${empIdx}-${timeIdx}`} colSpan={colSpan} sx={{ border: '1px solid #ccc' }}>
                      <div className="flex justify-between items-center bg-[#cbcaca] h-[50px] border-l-4 border-[#A5A5A5] rounded-lg bg-opacity-10 p-4">
                        <div>
                          <h1>{shift.shiftName.shiftName}</h1>
                          <h1 className="text-[#A5A5A5]">
                            {shift.shiftName.workedTime.from} - {shift.shiftName.workedTime.to}
                          </h1>
                        </div>
                        {/* {!employee.isDefault && (
                          <IconButton>
                            <MdOutlineModeEdit />
                          </IconButton>
                        )} */}
                      </div>
                    </TableCell>
                  );

                  timeIdx += colSpan;
                  shiftRendered = true;
                  break;
                }
              }

              if (!shiftRendered) {
                rowCells.push(<TableCell key={`${empIdx}-${timeIdx}`} sx={{ border: '1px solid #ccc' }} />);
                timeIdx += 1;
              }
            }

            return (
              <TableRow key={empIdx}>
                <TableCell sx={{ border: '1px solid #ccc' }}>{employee.employeeName}</TableCell>
                {rowCells}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

  const { mode } = useTheme();

  const WeeklyBasedEmployeeShiftMappingTableView = ({ employeeShifts, selectedDate }) => {
    console.log(employeeShifts, "employeeShiftsemployeeShifts")
    const getCurrentWeekDays = () => {
      const start = selectedDate?.startOf("isoWeek"); // Monday
      return Array.from({ length: 7 }).map((_, i) => {
        const day = addDays(start.toDate(), i);
        return {
          label: format(day, "EEE dd"), // e.g., "Mon 01"
          date: format(day, "yyyy-MM-dd"), // for filtering
        };
      });
    };
    const days = getCurrentWeekDays(); // dynamic days

    return (
      <div className="overflow-x-auto rounded-md mt-5">
        <table className={`min-w-full border-collapse ${mode === "dark" ? "border border-[#353535]" : ""}`}>
          <thead className="sticky top-0 bg-white ">
            <tr className={`text-[#666666] ${mode === "light" ? "bg-[#E5E5F0]" : "bg-[#141414]"}`}>
              <th className={`p-4 sticky left-0 z-10 ${mode === "light" ? "bg-[#E5E5F0] border-t border-r border-[#f5f5f5]" : "bg-[#141414] border-t border-r border-[#353535]"}`}>
                <Checkbox />
              </th>
              <th className={`w-[350px] text-[#666666] font-[400] p-4 text-left sticky left-[40px] z-10 ${mode === "light" ? "bg-[#E5E5F0] border-t border-r border-[#f5f5f5]" : "bg-[#141414] border-t border-r border-[#353535]"}`}>
                Staff
              </th>
              {days.map(({ label }) => (
                <th key={label} className={`w-[200px] text-center font-[400] p-4 text-left ${mode === "light" ? "border-t border-r border-[#f5f5f5]" : "bg-[#141414] border-t border-r border-[#353535]"}`}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {employeeShifts?.map((employee, index) => (
              <tr key={index} className={`${mode === "light" ? "border-t" : "border-t border-[#353535]"}`}>
                <td className={`${mode === "light" ? "bg-white border-r border-t border-[#f5f5f5]" : "bg-[#141414] border-r border-t border-[#353535]"} h-[90px] text-center sticky left-0 z-10`}>
                  <Checkbox />
                </td>
                <td className={`h-[90px] w-[300px] flex items-center text-left gap-3 px-2 sticky left-[40px] z-10`} style={{ backgroundColor: mode === "light" ? "white" : "#141414" }}>
                  {/* <div className="w-8 h-8 flex items-center justify-center rounded-md">
                    <img className="rounded-md" src="/images/user-profile.png" alt="" style={{ width: "38px", height: "38px" }} />
                  </div> */}
                  <span className={`${mode === "light" ? "text-[#666666]" : ""}`}>{index + 1}</span>
                  <span className={`${mode === "light" ? "text-[#222222]" : ""}`}> - {employee?.employeeName}</span>
                </td>
                {days.map(({ date }) => {
                  const shift = employee.shifts.find(s => {
                    const from = new Date(s.fromDate).toISOString().split("T")[0];
                    const to = new Date(s.toDate).toISOString().split("T")[0];
                    return date >= from && date <= to;
                  });

                  return (
                    <td key={date} className="text-center">
                      <div className={`flex flex-col items-center w-[180px] justify-center px-3 h-[90px] ${mode === "light" ? "bg-[#f6f6f6]" : ""}`}>
                        {shift ? (
                          <div className={`${mode === "dark" ? "border-l-4 border-[#A5A5A5]" : ""} pl-2`}>
                            <p className={`text-[14px] font-[500] ${mode === "light" ? "text-[#222222]" : ""}`}>{shift?.shiftName?.shiftName}</p>
                            <p className="text-[14px] text-[#666666]">
                              {shift?.shiftName?.workedTime?.from} - {shift?.shiftName?.workedTime?.to}
                            </p>
                          </div>
                        ) : (
                          // <span className="text-[14px] text-[#999]">–</span>
                          <div className={`${mode === "dark" ? "border-l-4 border-[#A5A5A5]" : ""} pl-2`}>
                            <p className={`text-[14px] font-[500] ${mode === "light" ? "text-[#222222]" : ""}`}>General</p>
                            <p className="text-[14px] text-[#666666]">
                              09:00 AM - 06:00 PM
                            </p>
                          </div>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  const [switchScreen, setSwitchScreen] = useState({
    primary: "weeklyView",
  });

  const [assignShiftModal, setAssignShiftModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [open, setOpen] = useState(false);

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const shifts = ["General - 09:00 AM - 06:00 PM"];
  const employees = ["S1 - Steward Graham", "S2 - Lilly Williams"];
  const departments = ["HR", "IT", "Marketing", "Management"];
  const designations = [
    "CEO",
    "Team Member",
    "Manager",
    "Administration",
    "Assistant Manager",
  ];

  const handlePrevWeek = () => {
    if (switchScreen?.primary != "weeklyView") {
      setSelectedDate(prev => prev.subtract(1, 'day'));
    } else {
      setSelectedDate(selectedDate.subtract(7, "day"));
    }
  };

  const handleNextWeek = () => {
    if (switchScreen?.primary != "weeklyView") {
      setSelectedDate(prev => prev.add(1, 'day'));
    } else {
      setSelectedDate(selectedDate.add(7, "day"));
    }
  };
  const startOfWeeks = selectedDate?.startOf("isoWeek"); // Monday
  const endOfWeek = startOfWeeks?.add(6, "day"); // Sunday
  const formattedStart = startOfWeeks?.format("DD/MM/YYYY");
  const formattedEnd = endOfWeek?.format("DD/MM/YYYY");
  const formattedDate = selectedDate.format("DD/MM/YYYY");

  let currentOrg = JSON.parse(localStorage.getItem("org"));
  const [view, setView] = useState("Weekly");
  const [filteredShifts, setFilteredShifts] = useState([]);
  const [employeeShifts, setEmployeeShifts] = useState([]);

   const fetchEmployeeShifts = async () => {
      try {
        const res = await axios.get(`/hr/employeeShift/employee-shifts?adminId=${currentOrg?._id}`); // replace with actual URL
        setEmployeeShifts(res?.data?.data);
        setFilteredShifts(res.data.data);
      } catch (error) {
        console.error("Error fetching employee shifts", error);
      }
    };
  useEffect(() => {
    fetchEmployeeShifts();
  }, []);


  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedDesignations, setSelectedDesignations] = useState([]);
  const [selectedShifts, setSelectedShifts] = useState([]);

  const handleFilter = () => {
    let filtered = employeeShifts;

    if (selectedEmployees?.length > 0) {
      filtered = filtered?.filter(emp =>
        selectedEmployees?.includes(emp.employeeName)
      );
    }

    if (selectedDepartments.length > 0) {
      filtered = filtered?.filter(emp =>
        selectedDepartments?.includes(emp.department)
      );
    }

    if (selectedDesignations?.length > 0) {
      filtered = filtered?.filter(emp =>
        selectedDesignations.includes(emp.designation)
      );
    }

    if (selectedShifts?.length > 0) {
      filtered = filtered?.filter(emp =>
        emp.shifts.some(s => selectedShifts.includes(s.shiftName?.shiftName))
      );
    }

    // Handle date filtering only if period is custom
    if (selectedValue === "custom" && fromDate && toDate) {
      const from = fromDate.startOf("day").toDate();
      const to = toDate.endOf("day").toDate();

      filtered = filtered?.map(emp => ({
        ...emp,
        shifts: emp?.shifts?.filter(s => {
          const shiftFrom = new Date(s.fromDate);
          const shiftTo = new Date(s.toDate);
          return shiftTo >= from && shiftFrom <= to;
        }),
      }));
    }

    setFilteredShifts(filtered);
    setFilterModal(false);
  };

  return (
    <div className="p-3 h-full">
      <div className="flex justify-between items-center">
        <div className="w-full"> </div>

        <div className="w-full flex relative  items-center gap-2">
          {/* Previous Week Button */}
          <div
            className={`flex items-center gap-2 ${mode === "light" ? "bg-white" : "bg-[#1E1E1E]"
              } p-2 rounded-md`}
          >
            <IoIosArrowBack
              fontSize="small"
              className="cursor-pointer hover:text-gray-600"
              onClick={handlePrevWeek}
              sx={{ color: mode === "dark" ? "#A5A5A5" : "" }}
            />

            {/* Calendar Icon and Date Range Text */}
            <Box
              className="relative flex items-center rounded-md cursor-pointer"
            // onClick={() => setOpen((prev) => !prev)}
            >
              <IoCalendarOutline size="18px" sx={{ color: mode === "dark" ? "#A5A5A5" : "" }} />
            </Box>

            {/* Next Week Button */}
            <IoIosArrowForward
              fontSize="small"
              className="cursor-pointer hover:text-gray-600"
              onClick={handleNextWeek}
              sx={{ color: mode === "dark" ? "#A5A5A5" : "" }}
            />
          </div>

          <div className="text-sm flex gap-2 items-center font-medium">
            {switchScreen?.primary != "weeklyView" ? (
              <span>{formattedDate}</span>
            ) : (
              <>
                <span>{formattedStart}</span> - <span>{formattedEnd}</span>
              </>
            )}
          </div>


          {/* Calendar Popup */}
          {open && (
            <Box
              className={`absolute top-8 z-10 shadow-md border rounded-md ${mode === "light" ? "bg-white" : "bg-[#141414]"
                }`}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  value={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    setOpen(false);
                  }}
                />
              </LocalizationProvider>
            </Box>
          )}
        </div>

        <div className="flex gap-2 items-center">
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(e, newView) => newView && setView(newView)}
            sx={{
              height: "32px",
            }}
          >
            <ToggleButton
              value="Weekly"
              onClick={() => setSwitchScreen({ primary: "weeklyView" })}
              sx={{
                fontSize: { md: "14px", xs: "10px" },
                height: "32px",
                width: "80px",
                backgroundColor:
                  view === "Weekly" ? `${mode === "light" ? "#ffffff !important" : "transparent"} ` : "transparent",
                // border:
                //   view === "Weekly"
                //     ? "2px solid #0088ff"
                //     : "2px solid transparent",
                color: view === "Weekly" ? "black" : "grey",
              }}
            >
              Weekly
            </ToggleButton>
            <ToggleButton
              value="Monthly"
              onClick={() => setSwitchScreen({ primary: "dailyView" })}
              disableRipple
              sx={{
                fontSize: { md: "14px", xs: "10px" },
                height: "32px",
                width: "80px",
                backgroundColor:
                  view === "Monthly" ? `${mode === "light" ? "#ffffff !important" : "transparent"} ` : "transparent",
                // border:
                //   view === "Monthly"
                //     ? "2px solid #0088ff"
                //     : "2px solid transparent",
                color: view === "Monthly" ? "black" : "grey",
              }}
            >
              DAILY
            </ToggleButton>
          </ToggleButtonGroup>


          {/* <div className="flex items-center">
            <div
              onClick={() => setActiveTab("list")}
              className={`p-2 cursor-pointer rounded-[4px] ${activeTab === "list" ? "border-1 border-[#098cff]" : ""
                }`}
            >
              <LuLayoutList />
            </div>

            <div
              onClick={() => setActiveTab("grid")}
              className={`p-2 cursor-pointer ${activeTab === "grid" ? "border-1 border-[#098cff]" : ""
                }`}
            >
              <CgMenuGridO />
            </div>
          </div> */}

          <div className="flex gap-3 items-center">
            {currentOrg.type === "Owner" &&
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  // onClick={() =>
                  //   handleOpen("assign")
                  // }
                  // onClick={() => setOpen((prev) => !prev)}
                  onClick={() => {
                    setAssignShiftModal(true);
                  }}
                  sx={{
                    fontSize: { md: "14px", xs: "10px" },
                    height: "32px",
                    width: "130px",
                    backgroundColor: "#0080FF"
                  }}
                >
                  Assign Shift
                </Button>
              </div>
            }
            {/* <div
              onClick={() => {
                setFilterModal(true);
              }}
              className={`${mode === "light" ? "bg-[#fff]" : ""} rounded-md`}
            >
              <IoFilter size={"16px"} />
            </div> */}
          </div>
        </div>

      </div>

      <div className="w-full h-full">
        {switchScreen.primary === "weeklyView" ? (
          <>
            <WeeklyBasedEmployeeShiftMappingTableView employeeShifts={filteredShifts} selectedDate={selectedDate} />
          </>
        ) : (
          <></>
        )}
        {switchScreen.primary === "dailyView" ? (
          <>
            <DailyBasedEmployeeShiftMappingTableView employeeShifts={filteredShifts} formattedDate={selectedDate.format("DD/MM/YYYY")} />
          </>
        ) : (
          <></>
        )}
      </div>

      <div>
        <Dialog
          open={filterModal}
          onClose={() => setFilterModal(false)}
          fullWidth
          maxWidth="md"
          PaperProps={{
            sx: {
              borderRadius: "15px"
            },
          }}
        >
          <div className={`${mode === "dark" ? "bg-[#1F1F1F]" : ""} px-6 rounded-lg`}>
            <div className=" flex justify-between items-center py-4">
              <DialogTitle sx={{ padding: "0px", fontSize: "22px" }}>Filter</DialogTitle>
              <IoMdClose
                size={"24px"}
                className="cursor-pointer"
                onClick={() => setFilterModal(false)}
              />
            </div>
            <DialogContent sx={{ padding: "0px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <label className="mb-2 block text-[14px]">Period</label>
                  <FormControl fullWidth>
                    <Select
                      value={selectedValue}
                      onChange={(e) => setSelectedValue(e.target.value)}
                      sx={{ height: 40 }} // Yeh height set karne ke liye
                    >
                      <MenuItem value="today">Today</MenuItem>
                      <MenuItem value="yesterday">Yesterday</MenuItem>
                      <MenuItem value="thisWeek">This Week</MenuItem>
                      <MenuItem value="lastWeek">Last Week</MenuItem>
                      <MenuItem value="thisMonth">This Month</MenuItem>
                      <MenuItem value="lastMonth">Last Month</MenuItem>
                      <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} className="block">
                  <label className="block mb-2 text-[14px]">From</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={fromDate}
                      onChange={(newValue) => setFromDate(newValue)}
                      sx={{
                        minWidth: "100%",
                        "& .MuiOutlinedInput-root": { height: 35 }, // Input height fix
                        "& .MuiInputAdornment-root": {
                          backgroundColor: "transparent !important",
                        }, // Calendar icon ka bg remove
                        "& .MuiIconButton-root": {
                          backgroundColor: "transparent !important",
                        }, // Button ka bg bhi remove
                      }}
                      slots={{
                        textField: (params) => (
                          <TextField
                            {...params}
                            placeholder="dd - mm - yyyy"
                            variant="outlined"
                            size="small"
                            sx={{
                              "& input::placeholder": {
                                fontSize: "14px",
                                color: "#888",
                              },
                              "& input": {
                                fontSize: "14px",
                              },
                              "& .MuiOutlinedInput-root": {
                                padding: 0,
                                paddingX: 2
                              },
                              width: "100%"
                            }}
                          />
                        ),
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} className="block">
                  <label className="block mb-2 text-[14px]">To</label>
                  <LocalizationProvider
                    sx={{ padding: "0px" }}
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      value={toDate}
                      onChange={(newValue) => setToDate(newValue)}
                      sx={{
                        minWidth: "100%",
                        "& .MuiOutlinedInput-root": { height: 40 },
                        "& .MuiInputAdornment-root": {
                          backgroundColor: "transparent !important",
                        }, // Calendar icon ka bg remove
                        "& .MuiIconButton-root": {
                          backgroundColor: "transparent !important",
                        }, // Button ka bg bhi remove
                      }}
                      slots={{
                        textField: (params) => (
                          <TextField
                            {...params}
                            placeholder="dd - mm - yyyy"
                            variant="outlined"
                            size="small"
                            sx={{
                              "& input::placeholder": {
                                fontSize: "14px",
                                color: "#888",
                              },
                              "& input": {
                                fontSize: "14px",
                              },
                              "& .MuiOutlinedInput-root": {
                                padding: 0,
                                paddingX: 2
                              },
                              width: "100%"
                            }}
                          />
                        ),
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                  <label className="block mb-2 text-[14px]">Employee</label>
                  <Autocomplete
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        backgroundColor: "transparent !important", // Dropdown icon ka bg transparent
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        backgroundColor: "transparent !important", // Clear icon ka bg bhi transparent
                      },
                      "& .MuiOutlinedInput-root": {
                        display: "flex",
                        alignItems: "center", // Placeholder aur selected text center align
                        minHeight: 40, // Ensure height stays 40px
                      },
                      "& .MuiInputBase-root": {
                        minHeight: 40, // Input field ki height fix karna
                      },
                    }}
                    multiple
                    options={employees}
                    value={selectedEmployees}
                    onChange={(e, newValue) => setSelectedEmployees(newValue)}
                    getOptionLabel={(option) => option}
                    disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select employees"
                        sx={{
                          height: 40,
                          "& .MuiInputBase-root": {
                            height: 40,
                            display: "flex",
                            alignItems: "center", // Placeholder aur selected text center align
                          },
                          "& .MuiOutlinedInput-root": {
                            padding: 0,
                            paddingLeft: 2
                          },
                          "& input::placeholder": {
                            fontSize: "14px",
                            color: "#888",
                          },
                          "& input": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <label className="block mb-2 text-[14px]">Department</label>
                  <Autocomplete
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        backgroundColor: "transparent !important", // Dropdown icon ka bg transparent
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        backgroundColor: "transparent !important", // Clear icon ka bg bhi transparent
                      },
                      "& .MuiOutlinedInput-root": {
                        display: "flex",
                        alignItems: "center", // Placeholder aur selected text center align
                        minHeight: 40, // Ensure height stays 40px
                      },
                      "& .MuiInputBase-root": {
                        minHeight: 40, // Input field ki height fix karna
                      },
                    }}
                    multiple
                    options={departments}
                    getOptionLabel={(option) => option}
                    disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select departments"
                        sx={{
                          height: 40,
                          "& .MuiInputBase-root": {
                            height: 40,
                            display: "flex",
                            alignItems: "center", // Placeholder aur selected text center align
                          },
                          "& .MuiOutlinedInput-root": {
                            padding: 0,
                            paddingLeft: 2
                          },
                          "& input::placeholder": {
                            fontSize: "14px",
                            color: "#888",
                          },
                          "& input": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <label className="block mb-2 text-[14px]">Designation</label>
                  <Autocomplete
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        backgroundColor: "transparent !important", // Dropdown icon ka bg transparent
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        backgroundColor: "transparent !important", // Clear icon ka bg bhi transparent
                      },
                      "& .MuiOutlinedInput-root": {
                        display: "flex",
                        alignItems: "center", // Placeholder aur selected text center align
                        minHeight: 40, // Ensure height stays 40px
                      },
                      "& .MuiInputBase-root": {
                        minHeight: 40, // Input field ki height fix karna
                      },
                    }}
                    multiple
                    options={designations}
                    getOptionLabel={(option) => option}
                    disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select designations"
                        sx={{
                          height: 40,
                          "& .MuiInputBase-root": {
                            height: 40,
                            display: "flex",
                            alignItems: "center", // Placeholder aur selected text center align
                          },
                          "& .MuiOutlinedInput-root": {
                            padding: 0,
                            paddingLeft: 2
                          },
                          "& input::placeholder": {
                            fontSize: "14px",
                            color: "#888",
                          },
                          "& input": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <label className="block mb-2 text-[14px]">Shifts</label>
                  <Autocomplete
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        backgroundColor: "transparent !important", // Dropdown icon ka bg transparent
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        backgroundColor: "transparent !important", // Clear icon ka bg bhi transparent
                      },
                      "& .MuiOutlinedInput-root": {
                        display: "flex",
                        alignItems: "center", // Placeholder aur selected text center align
                        minHeight: 40, // Ensure height stays 40px
                      },
                      "& .MuiInputBase-root": {
                        minHeight: 40, // Input field ki height fix karna
                      },
                    }}
                    multiple
                    options={shifts}
                    getOptionLabel={(option) => option}
                    disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select shift"
                        sx={{
                          height: 40,
                          "& .MuiInputBase-root": {
                            height: 40,
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiOutlinedInput-root": {
                            padding: 0,
                            paddingLeft: 2
                          },
                          "& input::placeholder": {
                            fontSize: "14px",
                            color: "#888",
                          },
                          "& input": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>


            <div className="flex justify-between items-center mt-5 pb-4">
              <Button onClick={handleFilter} variant="contained" sx={{ backgroundColor: "#0080FF", width: "120px" }}>
                Submit
              </Button>
              <Button
                onClick={() => setFilterModal(false)}
                variant="outlined"
                sx={{ width: "120px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
      <AssignShiftModal
        open={assignShiftModal}
        handleClose={() => setAssignShiftModal(false)}
        fetchEmployeeShifts={fetchEmployeeShifts}
      />
    </div>
  );
}